export const NGINX_HEADERS = {
  MOBILE: 'x-is-mobile',
  VIEWPORT: 'viewport-width',
  COUNTRY: 'nginx_geoip_country_code',
  HOST: 'nginx_url_host',
} as const;

export const APP_HEADERS = {
  MOBILE: 'x-app-render-mobile-version',
  COUNTRY: 'x-app-country-code',
  FORCE_IS_CF_VERIFIED_BOT: 'force-is-cf-verified-bot',
} as const;

export const VERCEL_HEADERS = {
  HOST: 'x-nexturl-host',
  URL: 'x-url',
  PATHNAME: 'x-pathname',
  PROTOCOL: 'x-protocol',
  COUNTRY: 'x-geo-country-code',
  COUNTRY_REGION: 'x-geo-country-region',
  CITY: 'x-vercel-ip-city',
  DEVICE_TYPE: 'x-device-type',
  IS_BOT: 'x-is-bot',
  BLOCK_THIRD_PARTY_SCRIPTS: 'x-block-third-party-scripts',
  SPOTLIGHT_PRODUCT_ID: 'x-cap-product-id',
  SPOTLIGHT_REFERER_CATEGORY_SLUG: 'x-cap-category-slug',
  SPOTLIGHT_REFERER_SUBCATEGORY_SLUG: 'x-cap-subcategory-slug',
  FORWARDED_FOR: 'x-forwarded-for',
  REAL_IP: 'x-real-ip',
  CAP_SEM_CATEGORY_SLUG: 'x-cap-sem-category-slug',
} as const;

export const CLOUDFLARE_HEADERS = {
  IS_BOT: 'cf-verified-bot',
  BOT_SCORE: 'cf-bot-score',
  X_REQUEST_ID: 'x-request-id',
  TRUE_CLIENT_IP: 'true-client-ip',
  CF_CONNECTING_IP: 'cf-connecting-ip',
  VERIFIED_BOT_CATEGORY: 'x-cloudflare-verified-bot-category',
} as const;

export enum OneTrustHeaders {
  GROUPS = 'groups',
  OPTANON_CONSENT = 'OptanonConsent',
}

export enum TrackingHostNames {
  CAPTERRA_PROD = 'capterra.com',
  CAPTERRA_STG = 'capstage.net',
}

export const PERIMETER_X_SCORE = 'x-px-score';
